export const menus = ["home", "about", "projects", "experience", "contact", "loader"]